import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputOtpModule } from 'primeng/inputotp';
import { InputTextModule } from 'primeng/inputtext';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';
import { getUniqueId } from '../../../functions/get-unique-id';
@Component({
  selector: 'app-input-otp',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    InputOtpModule,
    HelpTextComponent,
  ],
  template: `
    <p-inputotp
      [formControl]="control"
      size="large"
      [integerOnly]="false"
      [length]="6"
    >
      <ng-template #input let-token let-events="events" let-index="index">
        <input
          type="text"
          pInputText
          tabindex="0"
          autocomplete="off"
          [id]="id + '-' + index"
          aria-label="One time code field"
          [attr.maxlength]="1"
          [value]="token ?? ''"
          class="p-inputtext p-inputotp-input p-inputtext-lg"
          (keyup)="keypress($event)"
          (input)="events.input($event)"
          (paste)="events.paste($event)"
        />
      </ng-template>
    </p-inputotp>
    @if (showHelpText) {
      <app-help-text [control]="control" [helpText]="helpText" />
    }
    <input type="submit" #hiddenSubmit style="display:none;" />
  `,
  styles: ``,
})
export class InputOtpComponent extends BaseControlComponent {
  @ViewChild('hiddenSubmit')
  hiddenSubmit: ElementRef<any>;

  keypress(event: any) {
    if (event.code === 'Enter') {
      if (this.control.parent.valid) {
        this.hiddenSubmit.nativeElement.click();
      }
    }
  }

  override id = getUniqueId('app-input-otp');
}
